// extracted by mini-css-extract-plugin
export var adjacentSlide = "_p5-9";
export var arrowButtonContainer = "_p5-5";
export var arrowButtonIcon = "_p5-6";
export var carouselArrowButton = "_p5-2";
export var carouselElementContainer = "_p5-1";
export var currentSlide = "_p5-8";
export var left = "_p5-3";
export var otherSlide = "_p5-a";
export var productCarouselContainer = "_p5-0";
export var right = "_p5-4";
export var sliderOverflow = "_p5-7";